import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Login from './components/Login';
import InboundOrder from './components/InboundOrder';
import ProtectedRoute from './components/ProtectedRoute';
import RFTerminal from './components/RFTerminal';
import RFReceiveOrder from './components/RFReceiveOrder';
import RFPutaway from './components/RFPutaway';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/inbound-order" 
            element={
              <ProtectedRoute>
                <InboundOrder />
              </ProtectedRoute>
            } 
          />
          <Route path="/rf" element={<RFTerminal />} />
          <Route path="/rf/receive" element={<RFReceiveOrder />} />
          <Route path="/rf/putaway" element={<RFPutaway />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App; 